import { Box, Button, FormControlLabel, FormHelperText, Switch, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import config from '../config.json';
import axiosAuth from '../utils/axiosAuth';

const configItemStyle = {
    width: '250px',
    justifyContent: 'space-between',
    display: 'inline-flex'
}

const messageStyle = {
    margin: '5px 10px',
    fontSize: '1rem', 
    textAlign: 'center'

}

const ConfigureTeamComponent = ({ teamData, setTeamData }) => {
    const [allowLogout, setAllowLogout] = useState(false);
    const [teamConfMessage, setTeamConfMessage] = useState(' ');
    const [teamConfMessageStyle, setTeamConfMessageStyle] = useState({color: 'red'});
    const [isSaving, setIsSaving] = useState(false);
    const [dataToUpdate, setDataToUpdate] = useState(false);
    const [maxPlayersError, setMaxPlayersError] = useState(false);
    const [maxPlayersInput, setMaxPlayersInput] = useState('0');

    const environment = process.env.REACT_APP_ENV;
    const baseApiUrl = environment ? config[environment].apiUrl : config.dev.apiUrl;
    const teamApiUrl = baseApiUrl + `teams/${teamData.id}`


    useEffect(() => {
        setAllowLogout(teamData.allowLogout || false);
        setMaxPlayersInput(teamData.maxPlayers);
    }, [teamData.allowLogout, teamData.maxPlayers]);

    const printUnsuccesfulTeamConfMessage = (msg) => {
        setTeamConfMessage(msg);
        setTeamConfMessageStyle({ color: 'red' });
    }

    const printSuccesfulTeamConfMessage = (msg) => {
        setTeamConfMessage(msg);
        setTeamConfMessageStyle({ color: 'green' });
    }

    const handleAllowLogoutSwitchChange = (event) => {
        setAllowLogout(event.target.checked);
        checkDataToUpdate(event.target.checked, maxPlayersInput);
        
    };

    const handleMaxPlayersInputChange = (event) => {
        setMaxPlayersInput(event.target.value);
        if (!event.target.value) {
            console.log('no value');
            setMaxPlayersError(true);
            setDataToUpdate(false);
            return;
        }
        else if (parseInt(event.target.value) > 100) {
            setMaxPlayersError(true);
            setDataToUpdate(false);
            return;
        }
        setMaxPlayersError(false);
        checkDataToUpdate(allowLogout, parseInt(event.target.value));
    };

    const checkDataToUpdate = (newAllowLogout, newMaxPlayers) => {
        if (newAllowLogout !== teamData.allowLogout || newMaxPlayers !== teamData.maxPlayers) {
            setDataToUpdate(true);
        }
        else {
            setDataToUpdate(false);
        }
    }

    const updateTeamDataOnServer = async (updatedFields) => {
        const retries = 3;
        let updatedTeamData = {
            ...teamData,
            ...updatedFields,
        }
        for (let i = 0; i < retries; i++) {
            try {
                if (i > 0) {
                    let teamGetResponse = await axiosAuth.get(teamApiUrl);
                    updatedTeamData = {
                        ...teamGetResponse.data,
                        ...updatedFields
                    };
                }
                updatedTeamData.version++;

                const teamPutResponse = await axiosAuth.put(teamApiUrl, updatedTeamData);
                console.log(teamPutResponse);
                setTeamData(updatedTeamData);
                printSuccesfulTeamConfMessage('Team configuration saved');
                setDataToUpdate(false);
                break;
            } catch (error) {
                if (!error.response) {
                    console.log(error);
                }
                else {
                    printUnsuccesfulTeamConfMessage('Save failed, please try again later.')
                    console.log(error);
                }
            }
        }
    };

    const handleSave = async () => {
        setTeamConfMessage(' ');

        if (parseInt(maxPlayersInput) < teamData.autoLoginPlayers.length) {
            printUnsuccesfulTeamConfMessage('Maximum number of players must be greater than the number of autologin players.');
            setMaxPlayersError(true);
            return;
        }
        setIsSaving(true);
        
        const updatedFields = {
            allowLogout: allowLogout,
            maxPlayers: parseInt(maxPlayersInput)
        }

        await updateTeamDataOnServer(updatedFields);
        setIsSaving(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSave();
    };


return (
    <form className="configure-team-form" onSubmit={handleSubmit}>
        <FormControlLabel
        sx={configItemStyle}
        labelPlacement="start"
        control={
            <Box display="flex" alignItems="center">
                <TextField
                    error={maxPlayersError}
                    style={{ width: '70px', height: '40px'}}
                    type="number"
                    variant="outlined"
                    size="small"
                    value={maxPlayersInput}
                    onChange={handleMaxPlayersInputChange}
                    InputProps={{
                        inputProps: {
                            min: 1,    // Set your desired minimum value
                            step: 1   // Set the desired interval
                        }
                    }}
                />
            </Box>
        }
        label="Max Players:"
        />
        <FormControlLabel
        sx={configItemStyle}
        labelPlacement="start"
        control={
          <Switch
            checked={allowLogout}
            onChange={handleAllowLogoutSwitchChange}
            name="allowPlayerLogout"
            color="primary"
          />
        }
        label="Allow Player Logout:"
        />
        <Button type='submit' variant="contained" color="primary" disabled={!dataToUpdate || isSaving}>
            Save
        </Button>
        <FormHelperText sx={{ ...teamConfMessageStyle, ...messageStyle }}>
            {teamConfMessage}
        </FormHelperText>
    </form>
);
}

export default ConfigureTeamComponent;